<a class="btn-main-cat" (click)="search()">{{ mainCategory }}</a>
